import React from 'react';
import { DotGroup } from 'components/Dot';
import { useTranslation } from 'react-i18next';
import { ModalTemplate } from '../ModalTemplate';
import { useStepper } from 'hooks/useStepper';
import {
  OnboardingContainer, Slide, Slider, Step,
} from './styles';
import { steps, TOTAL_STEPS } from './constants';
import { useSwipeNavigation } from '~/hooks/useSwipeNavigation';

interface OnboardingRemoteControlModalProps {
  isOpen: boolean;
  onClose: () => void;
}

interface OnboardingContentProps {
  currentStep: number;
  onClickStep: (index: number) => void;
}

const OnboardingContent: React.FC<OnboardingContentProps> = ({
  currentStep,
  onClickStep,
}) => {
  const { t } = useTranslation();

  function onDotClick(index: number): void {
    if (index !== currentStep - 1) {
      onClickStep(index + 1);
    }
  }

  const divReference = useSwipeNavigation({
    onSwipeRight: () => onClickStep(currentStep - 1),
    onSwipeLeft: () => onClickStep(currentStep + 1),
  });

  return (
    <OnboardingContainer>
      <Slide ref={divReference}>
        <Slider currentStep={currentStep}>
          {steps.map(({ description, imgPath, title }, index) => (
            <Step key={`${title.toLowerCase()}-${index}`}>
              <img
                src={imgPath}
                alt={`Imagem - ${t('Controle Inteligente')} - ${t(title).toLowerCase()}`}
              />
              <div>
                <h2>{t(title)}</h2>
                <p>{t(description)}</p>
              </div>
            </Step>
          ))}
        </Slider>
      </Slide>
      <div>
        <DotGroup
          numberDots={TOTAL_STEPS}
          selectedIndex={currentStep - 1}
          onDotClick={onDotClick}
        />
      </div>
    </OnboardingContainer>
  );
};

export const OnboardingRemoteControlModal: React.FC<OnboardingRemoteControlModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  const { activeStep, nextStep, defineStep } = useStepper(TOTAL_STEPS);

  function onClickNext(): void {
    if (activeStep !== TOTAL_STEPS) {
      nextStep();
    } else {
      onClose();
    }
  }

  return (
    <ModalTemplate
      padding={24}
      isOpen={isOpen}
      onClose={onClose}
      title=" "
      imageText={(
        <OnboardingContent
          currentStep={activeStep}
          onClickStep={defineStep}
        />
      )}
      button1={t(activeStep === TOTAL_STEPS ? 'abrirControleInteligente' : 'proximo')}
      button1Action={onClickNext}
      variant="large"
      fullScreenMobile
    />
  );
};
